import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import * as i0 from "@angular/core";
export class CustomBenchmarkSelectorModalModule {
}
CustomBenchmarkSelectorModalModule.ɵfac = function CustomBenchmarkSelectorModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomBenchmarkSelectorModalModule)(); };
CustomBenchmarkSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CustomBenchmarkSelectorModalModule });
CustomBenchmarkSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, IconSearchAutocompleteModule, ModalBaseModule, TooltipModule] });
